import React from "react";
import {
  ChartComponentProps,
  ChartConfig,
  CoinDataPoint,
  createChartConfig,
} from "src/components/Referral-partner/Analytics/analyticsTypes";
import CustomerAssetsHeld from "src/components/Referral-partner/Analytics/charts/CustomerAssetsHeld";
import { WarningWrapper } from "src/components/Referral-partner/Analytics/styles/shared.styles";
import api from "src/store/features/api";

const useGetReferralHoldingsConfig = (): { referralHoldings: ChartConfig<CoinDataPoint> } => {
  // fetch data and states
  const {
    data: rawHoldings,
    isLoading: holdingsIsLoading,
    isFetching: holdingsIsFetching,
    isError: holdingsIsError,
    error: holdingsError,
  } = api.useGetReferralHoldingsQuery();

  // format data
  const holdingsData = React.useMemo((): CoinDataPoint[] => {
    if (!rawHoldings) return [];
    return rawHoldings.data.map(
      (holding): CoinDataPoint => ({
        name: holding.name,
        value: holding.percentage,
      }),
    );
  }, [rawHoldings]);

  // create chart config
  const referralHoldingsConfig = React.useMemo(
    (): { referralHoldings: ChartConfig<CoinDataPoint> } => ({
      referralHoldings: createChartConfig<CoinDataPoint>({
        title: "Customer Assets Held",
        type: "pie",
        menuMode: "compact",
        defaultDate: "all time",
        dateOptions: [
          {
            label: "all time",
            value: "ALL",
          },
        ],
        tooltip: "Top 5 Assets Held by Your Referrals",
        isLoading: holdingsIsLoading || holdingsIsFetching,
        data: holdingsData,
        component: ({ data }: ChartComponentProps<CoinDataPoint>): JSX.Element => {
          if (holdingsIsError) {
            return <WarningWrapper>{holdingsError?.message}</WarningWrapper>;
          } else if (data.length <= 0) {
            return <WarningWrapper color="#002035">No Data</WarningWrapper>;
          } else {
            return <CustomerAssetsHeld data={data} />;
          }
        },
      }),
    }),
    [holdingsData, holdingsIsLoading, holdingsIsFetching, holdingsIsError, holdingsError],
  );

  return referralHoldingsConfig;
};

export default useGetReferralHoldingsConfig;
